<template>
    <div>
        <ModalUploadPlatformPushCertificate
            ref="modalUploadPlatformPushCertificate"
            platform=""
            @created="loadApplicationSnsPlatforms"
        />
        <ModalUploadStoreCertificate
            ref="modalUploadStoreCertificate"
            platform=""
            @created="loadApplicationStoreCertificates"
        />
        <ModalUploadPromokit
            ref="modalUploadPromokit"
            @created="loadApplicationPromokitStatus"
        />
        <table class="w-full table-fixed">
            <thead>
                <tr>
                    <th class="py-2 px-2 uppercase">{{ $t('admin.apps.status.service') }}</th>
                    <th class="py-2 px-2 uppercase">{{ $t('admin.photos.status') }}</th>
                    <th class="py-2 px-2 uppercase">{{ $t('apps.photos.actions') }}</th>
                </tr>
            </thead>
            <tbody class="bg-white">

                <tr class="border-solid border-grey border-b-1 border-0">
                    <td class="p-2">Smart link</td>
                    <td class="p-2">
                        <a :href="application.share_app_link" target="_blank" class="m-0 text-sm">
                            {{ application.share_app_link }}
                        </a>
                    </td>
                    <td class="p-2">
                    </td>
                </tr>

                <tr class="border-solid border-grey border-b-1 border-0">
                    <td class="p-2">API Key</td>
                    <td class="p-2">
                        <p class="m-0" :class="{'text-success': apiKeyEnabled, 'text-danger': !apiKeyEnabled}" >
                            {{ apiKeyEnabled ? $t('admin.apps.status.enabled') : $t('admin.apps.status.disabled') }}
                        </p>
                    </td>
                    <td class="p-2">
                        <vx-tooltip :text="apiKeyEnabled ? $t('admin.apps.status.disable') : $t('admin.apps.status.enable')" position="top" delay=".3s" class="m-0">
                            <button class="sk-btn sk-btn-small sk-btn-primary rounded-lg btn-border" @click="toggleApiKeyStatus" >
                                <feather-icon :icon="apiKeyEnabled ? 'XIcon' : 'CheckIcon'" svgClasses="text-primary align-middle w-6" class="align-middle"/>
                            </button>
                        </vx-tooltip>
                    </td>
                </tr>

                <tr class="border-solid border-grey border-b-1 border-0">
                    <td class="p-2">Push Android</td>
                    <td class="p-2">
                        <p class="m-0" :class="{'text-success': push.android === true, 'text-danger': push.android === false, 'text-grey': push.android === null}" >
                            {{ pushAndroidStatus }}
                        </p>
                    </td>
                    <td class="p-2">
                        <vx-tooltip :text="$t('admin.apps.status.certificate.upload_certificate')" position="top" delay=".3s" class="m-0">
                            <button class="sk-btn sk-btn-small sk-btn-primary rounded-lg btn-border" @click="openCertificateModal('android')" >
                                <feather-icon icon="UploadIcon" svgClasses="text-primary align-middle w-6" class="align-middle"/>
                            </button>
                        </vx-tooltip>
                    </td>
                </tr>

                <tr class="border-solid border-grey border-b-1 border-0">
                    <td class="p-2">Push iOS</td>
                    <td class="p-2">
                        <p class="m-0" :class="{'text-success': push.ios === true, 'text-danger': push.ios === false, 'text-grey': push.ios === null}" >
                            {{ pushIosStatus }}
                        </p>
                    </td>
                    <td class="p-2">
                        <vx-tooltip :text="$t('admin.apps.status.certificate.upload_certificate')" position="top" delay=".3s" class="m-0">
                            <button class="sk-btn sk-btn-small sk-btn-primary rounded-lg btn-border" @click="openCertificateModal('ios')" >
                                <feather-icon icon="UploadIcon" svgClasses="text-primary align-middle w-6" class="align-middle"/>
                            </button>
                        </vx-tooltip>
                    </td>
                </tr>

                <tr class="border-solid border-grey border-b-1 border-0">
                    <td class="p-2">Store Certificate Android</td>
                    <td class="p-2">
                        <feather-icon :icon="storeCertificates.android ? 'CheckIcon' : 'XIcon'" svgClasses=" align-middle w-6" :class="{'align-middle' : true, 'text-success': storeCertificates.android, 'text-danger': storeCertificates.android === null}"/>
                    </td>
                    <td class="p-2">
                        <vx-tooltip :text="$t('admin.apps.status.certificate.upload_certificate')" position="top" delay=".3s" class="m-0">
                            <button class="sk-btn sk-btn-small sk-btn-primary rounded-lg btn-border" @click="openStoreCertificateModal('android')" >
                                <feather-icon icon="UploadIcon" svgClasses="text-primary align-middle w-6" class="align-middle"/>
                            </button>
                        </vx-tooltip>
                    </td>
                </tr>

                <tr class="border-solid border-grey border-b-1 border-0">
                    <td class="p-2">Store Certificate iOS</td>
                    <td class="p-2">
                        <feather-icon :icon="storeCertificates.ios ? 'CheckIcon' : 'XIcon'" svgClasses=" align-middle w-6" :class="{'align-middle' : true, 'text-success': storeCertificates.ios, 'text-danger': storeCertificates.ios === null}"/>
                    </td>
                    <td class="p-2">
                        <vx-tooltip :text="$t('admin.apps.status.certificate.upload_certificate')" position="top" delay=".3s" class="m-0">
                            <button class="sk-btn sk-btn-small sk-btn-primary rounded-lg btn-border" @click="openStoreCertificateModal('ios')" >
                                <feather-icon icon="UploadIcon" svgClasses="text-primary align-middle w-6" class="align-middle"/>
                            </button>
                        </vx-tooltip>
                    </td>
                </tr>

                <tr class="border-solid border-grey border-b-1 border-0">
                    <td class="p-2">Firestore</td>
                    <td class="p-2"></td>
                    <td class="p-2">
                        <vx-tooltip :text="$t('admin.apps.status.refresh')" position="top" delay=".3s" class="m-0">
                            <button class="sk-btn sk-btn-small sk-btn-primary rounded-lg btn-border" @click="refreshFirestore" >
                                <feather-icon icon="RefreshCwIcon" svgClasses="text-primary align-middle w-6" class="align-middle"/>
                            </button>
                        </vx-tooltip>
                    </td>
                </tr>

                <tr class="border-solid border-grey border-b-1 border-0">
                    <td class="p-2">Promokit</td>
                    <td class="p-2">
                        <feather-icon :icon="promokit ? 'CheckIcon' : 'XIcon'" svgClasses=" align-middle w-6" :class="{'align-middle' : true, 'text-success': promokit, 'text-danger': promokit === null}"/>
                    </td>
                    <td class="p-2">
                        <vx-tooltip :text="$t('admin.apps.status.certificate.upload_certificate')" position="top" delay=".3s" class="m-0">
                            <button class="sk-btn sk-btn-small sk-btn-primary rounded-lg btn-border" @click="openPromokitModal" >
                                <feather-icon icon="UploadIcon" svgClasses="text-primary align-middle w-6" class="align-middle"/>
                            </button>
                        </vx-tooltip>
                    </td>
                </tr>

                <tr class="border-solid border-grey border-b-1 border-0">
                    <td class="p-2">App Figures</td>
                    <td class="p-2">
                        <input
                            v-if="isEditingAppFigures"
                            v-model="appFiguresInput"
                            type="text"
                            class="w-full px-2 py-1"
                            placeholder="figure-1, figure-2"
                        >
                        <p v-else class="m-0">{{ appFiguresDisplay }}</p>
                    </td>
                    <td class="p-2">
                        <template v-if="isEditingAppFigures">
                            <button class="sk-btn sk-btn-small sk-btn-primary rounded-lg btn-border mr-2" @click="saveAppFigures">
                                Save
                            </button>
                            <button class="sk-btn sk-btn-small sk-btn-primary rounded-lg btn-border" @click="cancelEditAppFigures">
                                Cancel
                            </button>
                        </template>
                        <button v-else class="sk-btn sk-btn-small sk-btn-primary rounded-lg btn-border" @click="startEditAppFigures">
                            Edit
                        </button>
                    </td>
                </tr>

            </tbody>
        </table>
    </div>
</template>

<script>

import loader from "@/modules/Shared/Mixins/loader";
import ApplicationService from "@/modules/Admin/Services/ApplicationService";
import ModalUploadPlatformPushCertificate from "@/modules/Admin/Components/Apps/ModalUploadPlatformPushCertificate.vue";
import ModalUploadStoreCertificate from "@/modules/Admin/Components/Apps/ModalUploadStoreCertificate.vue";
import ModalUploadPromokit from "@/modules/Admin/Components/Apps/ModalUploadPromokit.vue";

export default {
  name: "AppStatus",
  components: {ModalUploadPlatformPushCertificate, ModalUploadPromokit, ModalUploadStoreCertificate},
  mixins: [loader],
  props: {
    application: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
       apiKeyEnabled: false,
       push: {
           android: null,
           ios: null
       },
       promokit: null,
       storeCertificates: {
            android: null,
            ios: null
       },
       appFigures: [],
       appFiguresInput: '',
       isEditingAppFigures: false,
    }
  },
  methods: {
    async onActive() {
        await this.loadAndNotifyError(async () => {
            try {
                const gatewayResponse = await ApplicationService.getApplicationGateway(this.$route.params.uuid)
                this.apiKeyEnabled = gatewayResponse.enabled
            } catch (error) {
                console.log('No gateway', error)
                this.apiKeyEnabled = false
            }

            await this.loadApplicationSnsPlatforms()
            await this.loadApplicationPromokitStatus()
            await this.loadApplicationStoreCertificates()
        })
        await this.loadAndNotifyError(async () => {
            await this.loadApplicationAppFigures()
        })
    },
    async toggleApiKeyStatus() {
        await this.loadAndNotifyError(async () => {
            await ApplicationService.changeApplicationGatewayStatus(this.$route.params.uuid, {enabled: !this.apiKeyEnabled})
            this.apiKeyEnabled = !this.apiKeyEnabled
        })
    },
    async loadApplicationSnsPlatforms() {
        this.push = await ApplicationService.getApplicationSnsPlatformsStatus(this.$route.params.uuid)
    },
    async loadApplicationPromokitStatus() {
        const promokit = await ApplicationService.getApplicationPromokitStatus(this.$route.params.uuid)
        if (promokit) {
            this.promokit = promokit.last_modified
        }
    },
    async loadApplicationStoreCertificates() {
        const storeCertificates = await ApplicationService.getApplicationStoreCertificates(this.$route.params.uuid)
        this.storeCertificates.android = storeCertificates.android ? storeCertificates.android.last_updated : null
        this.storeCertificates.ios = storeCertificates.ios ? storeCertificates.ios.last_updated : null
    },
    async loadApplicationAppFigures() {
        const appFiguresResponse = await ApplicationService.getApplicationAppFigures(this.$route.params.uuid)
        this.appFigures = this.normalizeAppFigureIds(this.getAppFigureIdsFromResponse(appFiguresResponse))
        if (!this.isEditingAppFigures) {
            this.appFiguresInput = this.appFigures.join(', ')
        }
    },
    getAppFigureIdsFromResponse(response) {
        if (Array.isArray(response)) {
            return response
        }
        if (response && Array.isArray(response.ids)) {
            return response.ids
        }
        return []
    },
    normalizeAppFigureIds(ids) {
        const seen = new Set()
        return (Array.isArray(ids) ? ids : [])
            .map(id => `${id}`.trim())
            .filter(id => id.length > 0)
            .filter(id => {
                if (seen.has(id)) {
                    return false
                }
                seen.add(id)
                return true
            })
    },
    normalizeAppFiguresInput(inputValue) {
        if (!inputValue) {
            return []
        }
        return this.normalizeAppFigureIds(inputValue.split(','))
    },
    startEditAppFigures() {
        this.appFiguresInput = this.appFigures.join(', ')
        this.isEditingAppFigures = true
    },
    cancelEditAppFigures() {
        this.appFiguresInput = this.appFigures.join(', ')
        this.isEditingAppFigures = false
    },
    async saveAppFigures() {
        const ids = this.normalizeAppFiguresInput(this.appFiguresInput)
        const isSaved = await this.loadAndNotify(async () => {
            await ApplicationService.editApplicationAppFigures(this.$route.params.uuid, ids)
        })
        if (!isSaved) {
            return
        }

        const isReloaded = await this.loadAndNotifyError(async () => {
            await this.loadApplicationAppFigures()
        })
        if (isReloaded) {
            this.isEditingAppFigures = false
        }
    },
    getPushStatusTranslation(platformValue) {
        switch (platformValue) {
            case null: return this.$t('admin.apps.status.not_set')
            case true: return this.$t('admin.apps.status.enabled')
            case false: return this.$t('admin.apps.status.disabled')
        }
    },
    getStoreCertificatesStatusTranslation(storeCertificatesValue) {
        if (storeCertificatesValue === null) {
            return this.$t('admin.apps.status.not_set')
        }
        return storeCertificatesValue.last_modified ? this.$t('admin.apps.status.enabled') : this.$t('admin.apps.status.disabled')
    },
    openCertificateModal(platform) {
        this.$refs.modalUploadPlatformPushCertificate.platform = platform
        this.$refs.modalUploadPlatformPushCertificate.open()
    },
    openStoreCertificateModal(platform) {
        this.$refs.modalUploadStoreCertificate.platform = platform
        this.$refs.modalUploadStoreCertificate.open()
    },
    openPromokitModal() {
        this.$refs.modalUploadPromokit.open()
    },
    async refreshFirestore() {
        await this.loadAndNotify(async () => {
            await ApplicationService.refreshApplicationFirestore(this.$route.params.uuid)
        })
    }
  },
  computed: {
      pushAndroidStatus() {
          return this.getPushStatusTranslation(this.push.android)
      },
      pushIosStatus() {
          return this.getPushStatusTranslation(this.push.ios)
      },
      appFiguresDisplay() {
          return this.appFigures.length > 0
              ? this.appFigures.join(', ')
              : this.$t('admin.apps.status.not_set')
      },
  }
};
</script>
